import { CommonModule } from '@angular/common';
import { Directive, Component, ChangeDetectionStrategy, ContentChildren, ElementRef, NgModule } from '@angular/core';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/**
 * This directive defines a header row within the `<nx-header>` component.
 */
var NxHeaderRowDirective = /** @class */ (function () {
    function NxHeaderRowDirective() {
    }
    NxHeaderRowDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: 'nx-header-row',
                    exportAs: 'NxHeaderRow',
                    host: {
                        'class': 'nx-header__row'
                    }
                },] }
    ];
    return NxHeaderRowDirective;
}());
/**
 * The `<nx-header>` component is the main application header.
 */
var NxHeaderComponent = /** @class */ (function () {
    function NxHeaderComponent() {
    }
    NxHeaderComponent.decorators = [
        { type: Component, args: [{
                    template: "<ng-content select=\"nx-header-row\"></ng-content>\n<ng-content></ng-content>\n",
                    // tslint:disable-next-line:component-selector
                    selector: 'nx-header, [nx-header]',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    host: {
                        'class': 'nx-header',
                        '[class.nx-header--single-row]': '_headerRows.length === 0'
                    },
                    styles: [":host(.nx-header:not(.nx-header--single-row)){display:flex;flex-direction:column}::ng-deep .nx-header__row,:host(.nx-header.nx-header--single-row){background-color:#fff;display:flex;align-items:center;padding:1px 24px 0;border-bottom:1px solid #d9d9d9;height:60px;justify-content:space-between}@media screen and (-ms-high-contrast:active){::ng-deep .nx-header__row,:host(.nx-header.nx-header--single-row){background-color:window}}::ng-deep .nx-header__link{border-bottom:4px solid transparent;padding-top:4px;text-decoration:none;display:block;margin-right:32px;white-space:nowrap}::ng-deep .nx-header__link::after{display:block;content:attr(text-content);font-weight:700;height:1px;overflow:hidden;visibility:hidden}::ng-deep .nx-header__link.is-active{color:#006192;border-color:currentColor}::ng-deep .nx-header__link.is-active .nx-header__link-title{font-weight:700}::ng-deep .nx-header__link:active,::ng-deep .nx-header__link:hover{color:#006192;border-color:#006192}::ng-deep .nx-header__link-title{line-height:0}::ng-deep .nx-header__brand{margin-right:24px;display:flex;align-items:center}::ng-deep .nx-header__actions{display:flex;align-items:center;margin-left:24px}:host-context([data-whatinput=keyboard]) ::ng-deep .nx-header__link:focus{box-shadow:0 0 0 2px #fff,0 0 0 6px #009de6;border-radius:4px}::ng-deep a:focus{outline:0}"]
                }] }
    ];
    NxHeaderComponent.propDecorators = {
        _headerRows: [{ type: ContentChildren, args: [NxHeaderRowDirective,] }]
    };
    return NxHeaderComponent;
}());
/**
 * This directive defines the header brand section within the `<nx-header>` component.
 */
var NxHeaderBrandDirective = /** @class */ (function () {
    function NxHeaderBrandDirective() {
    }
    NxHeaderBrandDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: 'nx-header-brand',
                    exportAs: 'NxHeaderBrand',
                    host: {
                        'class': 'nx-header__brand'
                    }
                },] }
    ];
    return NxHeaderBrandDirective;
}());
/**
 * This directive defines the header actions seciton within the `<nx-header>` component.
 */
var NxHeaderActionsDirective = /** @class */ (function () {
    function NxHeaderActionsDirective() {
    }
    NxHeaderActionsDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: 'nx-header-actions',
                    exportAs: 'NxHeaderActions',
                    host: {
                        'class': 'nx-header__actions'
                    }
                },] }
    ];
    return NxHeaderActionsDirective;
}());
/**
 * This component defines the header navigation section within the `<nx-header>` component.
 */
var NxHeaderNavigationComponent = /** @class */ (function () {
    function NxHeaderNavigationComponent() {
    }
    NxHeaderNavigationComponent.decorators = [
        { type: Component, args: [{
                    selector: 'nx-header-navigation',
                    exportAs: 'NxHeaderNavigation',
                    host: {
                        'class': 'nx-header__navigation',
                        role: 'navigation'
                    },
                    template: '<div role="list" class="nx-header__navigation-items"><ng-content></ng-content></div>',
                    styles: [":host(.nx-header__navigation){flex:1 1 auto}.nx-header__navigation-items{display:flex}"]
                }] }
    ];
    return NxHeaderNavigationComponent;
}());
/**
 * This directive defines a header navigation item within the `<nx-header-navigation>`.
 */
var NxHeaderNavigationItemDirective = /** @class */ (function () {
    function NxHeaderNavigationItemDirective() {
    }
    NxHeaderNavigationItemDirective.decorators = [
        { type: Directive, args: [{
                    // tslint:disable-next-line:directive-selector
                    selector: 'nx-header-navigation-item',
                    exportAs: 'NxHeaderNavigation',
                    host: {
                        role: 'listitem',
                        class: 'nx-header__navigation-item'
                    }
                },] }
    ];
    return NxHeaderNavigationItemDirective;
}());
/**
 * This component defines a header link within the `<nx-header>` component.
 */
var NxHeaderLinkComponent = /** @class */ (function () {
    function NxHeaderLinkComponent(_elementRef) {
        this._elementRef = _elementRef;
    }
    Object.defineProperty(NxHeaderLinkComponent.prototype, "textContent", {
        get: /**
         * @return {?}
         */
        function () {
            return this._elementRef.nativeElement.textContent;
        },
        enumerable: true,
        configurable: true
    });
    NxHeaderLinkComponent.decorators = [
        { type: Component, args: [{
                    // tslint:disable-next-line:component-selector
                    selector: 'a[nxHeaderLink]',
                    exportAs: 'NxHeaderLink',
                    host: {
                        'class': 'nx-header__link',
                        '[attr.text-content]': 'textContent'
                    },
                    template: '<span class="nx-header__link-title"><ng-content></ng-content></span>'
                }] }
    ];
    /** @nocollapse */
    NxHeaderLinkComponent.ctorParameters = function () { return [
        { type: ElementRef }
    ]; };
    return NxHeaderLinkComponent;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
/** @type {?} */
var EXPORTS = [
    NxHeaderComponent,
    NxHeaderLinkComponent,
    NxHeaderActionsDirective,
    NxHeaderNavigationComponent,
    NxHeaderBrandDirective,
    NxHeaderRowDirective,
    NxHeaderNavigationItemDirective
];
var NxHeaderModule = /** @class */ (function () {
    function NxHeaderModule() {
    }
    NxHeaderModule.decorators = [
        { type: NgModule, args: [{
                    declarations: EXPORTS,
                    exports: EXPORTS,
                    imports: [CommonModule]
                },] }
    ];
    return NxHeaderModule;
}());

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */

export { NxHeaderModule, NxHeaderRowDirective, NxHeaderComponent, NxHeaderBrandDirective, NxHeaderActionsDirective, NxHeaderNavigationComponent, NxHeaderNavigationItemDirective, NxHeaderLinkComponent };

//# sourceMappingURL=allianz-ngx-ndbx-header.js.map